import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { TARIFF_TYPES, getHousesForStreet, getStreetsForCity } from '@fttb/common';

// analytics
import { getCheckAddressCityId, getCheckAddressStreetFiasId, getCheckAddressStreetId, getFullAddress } from "../../../../../store/checkAddress/selectors";
import { mapHouseSuggestionsResponse, mapStreetSuggestionsResponse } from "../../../../../store/checkAddress/mappers";
import { POPUP_CONNECTION_STATE, popupSteps } from "../../../../../store/common/constants";
import { getTariffAlias } from "../../../../../store/blocks/tariffs/tariffSelectors";
import { getTargetTariffType } from "../selectors/orderTariffCommon";
import { backToPreviousStep, setNextStep, setStatusConnection } from "../reducers/slice";
import { getCurrentFormStep } from "../selectors/modal";
import { setFlat, setHouse, setStreet } from "./common";
import { setOrderTariffAddressWithYM } from "./helpers";
import { ymCheckConnectionTariffUp, ymOrderAlternativeTariffView, ymOrderTariffAddressView, ymOrderTariffCalendarView, ymOrderTariffDetailsView } from "../../analytics";
export var setFlatWithYm = function setFlatWithYm() {
  return function (dispatch, getState) {
    var _getTargetTariffType = getTargetTariffType(getState()),
      tariffType = _getTargetTariffType.tariffType;
    var addressFieldText = tariffType === TARIFF_TYPES.presetUp ? 'fmc_address_fill_field' : 'address_fill_field';
    ymOrderTariffAddressView(_defineProperty({}, addressFieldText, 'flat'), tariffType);
  };
};
export var setHouseWithYm = function setHouseWithYm(payload) {
  return function (dispatch, getState) {
    var _getTargetTariffType2 = getTargetTariffType(getState()),
      tariffType = _getTargetTariffType2.tariffType;
    setOrderTariffAddressWithYM(tariffType, 'house');
    dispatch(setHouse(payload));
  };
};
export var requestStreetSuggestions = function requestStreetSuggestions(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var cityId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(setStreetWithYm(payload));
            cityId = getCheckAddressCityId(getState());
            return _context.abrupt("return", getStreetsForCity(cityId, payload).then(mapStreetSuggestionsResponse));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var requestHouseSuggestions = function requestHouseSuggestions(term) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, streetId, fiasId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            dispatch(setHouseWithYm(term));
            streetId = getCheckAddressStreetId(state);
            fiasId = getCheckAddressStreetFiasId(state);
            return _context2.abrupt("return", getHousesForStreet(streetId, term, fiasId).then(mapHouseSuggestionsResponse));
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var setStreetWithYm = function setStreetWithYm(payload) {
  return function (dispatch, getState) {
    var _getTargetTariffType3 = getTargetTariffType(getState()),
      tariffType = _getTargetTariffType3.tariffType;
    setOrderTariffAddressWithYM(tariffType, 'street');
    dispatch(setStreet(payload));
  };
};
export var setStatusConnectionWithYm = function setStatusConnectionWithYm(payload) {
  return function (dispatch, getState) {
    var state = getState();
    var _getTargetTariffType4 = getTargetTariffType(state),
      tariffType = _getTargetTariffType4.tariffType;
    var fullAddress = getFullAddress(state);
    dispatch(setStatusConnection(payload));
    ymOrderTariffAddressView({
      address_check: "".concat(payload, ": ").concat(fullAddress)
    }, tariffType);
  };
};
export var setAddressStepWithYm = function setAddressStepWithYm(step) {
  return function (dispatch, getState) {
    var currentStep = getCurrentFormStep(getState());
    if (currentStep === popupSteps.alternativeTariff) {
      ymOrderAlternativeTariffView('tariff_address_edit');
    }
    if (currentStep === popupSteps.calendarForm) {
      ymOrderTariffCalendarView('address_edit');
    }
    if (currentStep === popupSteps.convergenceTariffs) {
      ymCheckConnectionTariffUp('fmc_tariff_address_edit');
    }
    if (currentStep === popupSteps.mobileTariffs) {
      ymCheckConnectionTariffUp('fmc_tariff_address_edit');
    }
    dispatch(setNextStep(step));
  };
};
export var backButtonClickWithYm = function backButtonClickWithYm() {
  return function (dispatch, getState) {
    var currentStep = getCurrentFormStep(getState());
    if (currentStep === popupSteps.tariffDetailsForm) {
      ymOrderTariffDetailsView('bid_back');
    }
    if (currentStep === popupSteps.calendarForm) {
      ymOrderTariffCalendarView('visit_back');
    }
    dispatch(setFlat(''));
    dispatch(setStatusConnection(POPUP_CONNECTION_STATE.isNone));
    dispatch(backToPreviousStep());
  };
};
export var sendOnClickTariffUpYm = function sendOnClickTariffUpYm() {
  return function (_, getState) {
    var alias = getTariffAlias(getState());
    ymCheckConnectionTariffUp({
      fmc_tariff_request: alias
    });
  };
};